import React from 'react';
import ReactMarkdown from 'react-markdown';

interface ContentSectionProps {
  title?: string;
  content: string;
}

const ContentSection: React.FC<ContentSectionProps> = ({
  content,
  title = null,
}) => (
  <div className="my-8 lg:my-44 lg:max-w-main lg:mx-auto subcontent">
    {title && <h2 className="text-4xl lg:text-6xl mb-8 lg:mb-20">{title}</h2>}
    <ReactMarkdown>{content}</ReactMarkdown>
  </div>
);

export default ContentSection;
